// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import $ from 'jquery'

import PageTop from '@/components/PageTop'
Vue.component('page-top', PageTop)
import PageBottom from '@/components/PageBottom'
Vue.component('page-bottom', PageBottom)
import Popup from '@/components/Popup'
Vue.component('popup', Popup)

import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = '/api'
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

global.menuItems = [
	{
		link: '/home',
		name: 'HOME',
		on: '———— [ ON ]'
	},
	{
		link: '/news',
		name: 'NEWS',
		on: '——— [ OPEN ]'
	},
	{
		link: '/story',
		name: 'STORY',
		on: '——— [ OPEN ]'
	},
	{
		link: '/keyword',
		name: 'KEYWORD',
		on: '— [ OPEN ]'
	},
	{
		link: '/character',
		name: 'CHARACTER',
		on: '[ OPEN ]'
	},
	
	{
		link: '/mechanics',
		name: 'MECHANICS',
		on: '[ OPEN ]'
	},
	{
		link: 'cast',
		name: 'STAFF&CAST',
		on: '[ OPEN ]'
	},
	{
		link: 'goods',
		name: 'GOODS',
		on: '—— [ OPEN ]'
	}
]

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js